/* eslint-disable react/jsx-props-no-spreading */
import {
    useCallback,
    useMemo,
} from 'react'
import noop from 'lodash/noop'

import {
    checkValidationError,
} from 'app/shared-components/utils/validation'

const EMPTY_OBJECT = {}
const EMPTY_ARRAY = []

type Props = {
    onChange: (value: any, event: any) => void,
    value?: any, // eslint-disable-line
    errors?: string[],
    uploadFiles?: (files: File[]) => void,
    exists?: boolean,
    isRequired?: boolean,
    fieldProps: {
        name?: string,
        type?: string,
        customComponent?: React.ComponentType<any>,
        passAllValues?: boolean,
    },
    componentValue?: any, // eslint-disable-line
    name: string,
    component: React.ComponentType<any>,
    setErrors?: (errors: string[]) => void,
}

const WrapperComponent = ({
    onChange,
    value = EMPTY_OBJECT,
    name,
    fieldProps,
    uploadFiles = noop,
    componentValue,
    exists = false,
    errors = EMPTY_ARRAY,
    isRequired = false,
    component: Component,
    setErrors = noop,
}: Readonly<Props>) => {
    const onHandleChange = useCallback((
        fieldValue,
        event,
        aggregation,
    ) => {
        onChange(
            {
                ...value,
                [name]: fieldValue,
                ...aggregation,
            }, event,
        )
    }, [
        name,
        onChange,
        value,
    ])

    const extendedFiledProps = useMemo(() => {
        return {
            ...fieldProps,
            values: fieldProps.passAllValues ? value : undefined,
        }
    }, [
        fieldProps,
        value,
    ])

    return (
        <>
            <Component
                {...extendedFiledProps}
                onChange={onHandleChange}
                uploadFiles={uploadFiles}
                value={componentValue}
                exists={exists}
                required={isRequired}
                setErrors={setErrors}
                hasError={checkValidationError(errors, name)}
            />
        </>
    )
}

export default WrapperComponent
